export default [
  {
    Company_Name: 'EXCLUSIVE CONSTRUCTION SERVICE',
    Service_Type: 'Contractor',
    Company_Address: '1005 W GRAND AVECHICAGO, IL 60622',
    Id: 81,
  },
  {
    Id: 10,
    Company_Name: 'AMERICAN ELECTRIC CONSTRUCTION COMPANY LLC',
    Service_Type: 'Contractor',
    Company_Address: '620 PRATT AVE NORTHSCHAUMBURG, IL 60193',
  },
  {
    Company_Address: '411 S WELLS ST STE 800CHICAGO, IL 60607',
    Id: 149,
    Service_Type: 'Engineer',
    Company_Name: 'E J M ENGINEERING, P.C.',
  },
  {
    Company_Name: 'RUDNY & SALLMANN ENGINEERING',
    Id: 200,
    Service_Type: 'Engineer',
    Company_Address: 'LTD, 3575 GRAND AVE STE AGURNEE, IL 60031-3774',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '1507 E SUNSET DRIVE-STE  125WAUKESHA, WI 53189-8213',
    Company_Name: 'MIDWEST ENGINEERING SERVICE, INC',
    Id: 187,
  },
  {
    Id: 15,
    Company_Name: 'B&B CONSTRUCTION & EXCAVATING',
    Service_Type: 'Contractor',
    Company_Address: '1288 E BUNGALOW RDMORRIS, IL 60450',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '851 S MORGAN ST RM 820 SEOCHICAGO, IL 60607',
    Company_Name: 'UIC ENGINEERING COUNCIL',
    Id: 219,
  },
  {
    Id: 16,
    Company_Address: '6615 N AVONDALE AVE FL 1STCHICAGO, IL 60631',
    Company_Name: 'BAYFIELD CONSTRUCTION INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'GENSLER ARCHITECTURE P C',
    Company_Address: '11 E MADISON ST # 300CHICAGO, IL 60606',
    Id: 107,
    Service_Type: 'Architect',
  },
  {
    Company_Address: '10 FOURTH STFRANKFORT, MI 49635',
    Company_Name: 'LUEDTKE ENGINEERING CO',
    Service_Type: 'Engineer',
    Id: 183,
  },
  {
    Company_Name: 'CONSTRUCTION CAREERS COUNCIL',
    Service_Type: 'Contractor',
    Company_Address: '5410 S STATE STCHICAGO, IL 60609',
    Id: 58,
  },
  {
    Id: 174,
    Company_Name: 'INTELLIGENT ENGINEERING & DESIGN LLC',
    Company_Address: 'PO BOX 337HINCKLEY, IL 60520',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '4125 S EMERALD AVE FL 1STCHICAGO, IL 60609',
    Company_Name: 'DEVRO CONSTRUCTION CO',
    Service_Type: 'Contractor',
    Id: 68,
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'AN L & J TECHNOLOGIES COMPANY, PO BOX 92136CHICAGO, IL 60675-2136',
    Id: 181,
    Company_Name: 'L & J ENGINEERING',
  },
  {
    Company_Address: '2220 ROUTE  176CRYSTAL LAKE, IL 60012',
    Id: 195,
    Service_Type: 'Engineer',
    Company_Name: 'PRESTRESS ENGINEERING CORP.',
  },
  {
    Company_Address: '3062 W 167TH STMARKHAM, IL 60426-5618',
    Service_Type: 'Contractor',
    Id: 39,
    Company_Name: 'CASTLE CONSTRUCTION CORPORATION.',
  },
  {
    Company_Name: 'BRECHEISEN ENGINEERING',
    Id: 132,
    Service_Type: 'Engineer',
    Company_Address: '516 W BRIAR PLCHICAGO, IL 60657',
  },
  {
    Company_Name: 'FISH CONSTRUCTION, INC.',
    Company_Address: '9820 CASH RDSTAFFORD, TX 77477-4423',
    Id: 89,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '175 W JACKSON BLVD # 1400CHICAGO, IL 60604',
    Id: 78,
    Service_Type: 'Contractor',
    Company_Name: 'ENVIRONMENTEL SYSTEMS DESIGN CONSTRUCTION, INC',
  },
  {
    Id: 113,
    Company_Name: 'REGINALD B. WILSON ARCHITECTURE',
    Company_Address: '601 E 32ND ST # 1203CHICAGO, IL 60616',
    Service_Type: 'Architect',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '851 S MORGAN ST RM 820 SEOCHICAGO, IL 60607',
    Company_Name: 'UIC ENGINEERING COUNCIL',
    Id: 219,
  },
  {
    Id: 48,
    Company_Name: 'CLARK CONSTRUCTION/ MCHUGH/',
    Company_Address: 'RAUSCH J/V, 216 S JEFFERSON STCHICAGO, IL 60661',
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '663 ACADEMY DRNORTHBROOK, IL 60062-2420',
    Id: 142,
    Company_Name: 'COMMERCIAL ENGINEERING CORP.',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Architect',
    Company_Name: 'DLK ARCHITECTURE, INC.',
    Id: 105,
    Company_Address: 'B/A DLK CIVIC DESIGN, RIVER PLACE 329 WEST 18TH STREETCHICAGO, IL 60616',
  },
  {
    Company_Address: '6 W HUBBARD ST FL 2NDCHICAGO, IL 60610',
    Id: 134,
    Company_Name: 'BUSINESS SYSTEMS ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'BIG JOHN CONSTRUCTION',
    Id: 26,
    Company_Address: '9909 W ROOSEVELT # 208-BWESTCHESTER, IL 60154',
  },
  {
    Company_Address: '1182 HEATHER DRLAKE ZURICH, IL 60047',
    Service_Type: 'Engineer',
    Id: 163,
    Company_Name: 'FRICKE COOPER ENGINEERING',
  },
  {
    Company_Name: 'TRAK ENGINEERING INC',
    Id: 217,
    Service_Type: 'Engineer',
    Company_Address: '2901 CRESCENT DRTALLAHASSEE, FL 32301-3535',
  },
  {
    Id: 37,
    Company_Name: 'CABO CONSTRUCTION CORP.',
    Company_Address: '3155 S SHIELDS AVECHICAGO, IL 60609',
    Service_Type: 'Contractor',
  },
  {
    Id: 196,
    Company_Name: 'QUANTUM ENGINEERING CORPORATION',
    Company_Address: '602 CAMDEN LNPORT BARRINGTON, IL 60010',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '3154-3160 S ARCHER AVECHICAGO, IL 60608-6293',
    Company_Name: 'ARCHER ENGINEERING CO',
    Id: 126,
  },
  {
    Id: 167,
    Company_Address: 'PO BOX 185CENTERVILLE, IN 47330',
    Service_Type: 'Engineer',
    Company_Name: 'GOLDEN ENGINEERING',
  },
  {
    Company_Name: 'PRESTRESS ENGINEERING CORP.',
    Company_Address: '2220 ROUTE  176CRYSTAL LAKE, IL 60012',
    Id: 195,
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'DEPT# 1501DENVER, CO 80291-2721',
    Company_Name: 'GLOBAL ENGINEERING DOCUMENTS',
    Id: 165,
  },
  {
    Company_Address: 'PO BOX 5564BUFFALO GROVE, IL 60089',
    Id: 203,
    Company_Name: 'SCHIRMER ENGINEERING CORP',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'FRICKE COOPER ENGINEERING',
    Id: 163,
    Service_Type: 'Engineer',
    Company_Address: '1182 HEATHER DRLAKE ZURICH, IL 60047',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '4260 WESTBROOK DRAURORA, IL 60504',
    Id: 157,
    Company_Name: 'ENGINEERING SERVICES GROUP, INC.',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '135 S LASALLE DEPT  1527CHICAGO, IL 60674-1527',
    Id: 119,
    Company_Name: 'ABRASIVE ENGINEERING',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'GANNA CONSTRUCTION CO',
    Id: 97,
    Company_Address: '1 PIERCE PL # 250-CITASCA, IL 60143-1253',
  },
  {
    Id: 218,
    Company_Address: '309 LINCOLN STBENSENVILLE, IL 60106',
    Company_Name: 'TRIMCO MANUFACTURING & ENGINEERING INC',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '6050 SOUTHPORT RD STE APORTAGE, IN 46368',
    Company_Name: 'CONSTRUCTION ADVANCEMENT FOUND',
    Id: 55,
  },
  {
    Company_Address: 'C/OLYMPIC TOWER #200, 300 PEARL STBUFFALO, NY 14202',
    Service_Type: 'Architect',
    Id: 109,
    Company_Name: 'INFORMATION ARCHITECTURE GROUP, IN',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 507HIGHTSTOWN, NJ',
    Id: 135,
    Company_Name: 'CHEMICAL ENGINEERING',
  },
  {
    Id: 145,
    Company_Name: 'D & F ENGINEERING, INC.',
    Service_Type: 'Engineer',
    Company_Address: '700 INDUSTRIAL DR STE 1-WBENSENVILLE, IL 60106',
  },
  {
    Company_Address: 'C/O  LAUREN FIELDS, 1735 NEW YORK AVENUE  NWWASHINGTON, DC 20006',
    Company_Name: 'AMERICAN INSTITUTE OF ARCHITECTURE STUDENTS',
    Service_Type: 'Architect',
    Id: 100,
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 1611BOSTON, MA',
    Company_Name: 'STONE & WEBSTER ENGINEERING',
    Id: 209,
  },
  {
    Company_Name: 'BENCHMARK CONSTRUCTION CO, INC',
    Service_Type: 'Contractor',
    Id: 21,
    Company_Address: '3741 S PULASKI RDCHICAGO, IL 60623',
  },
  {
    Id: 27,
    Company_Address: '935 W CHESTNUT STREET EFTCHICAGO, IL 60642',
    Service_Type: 'Contractor',
    Company_Name: 'BIGANE PAVING C/O PLOTE CONSTRUCTION INC JV',
  },
  {
    Service_Type: 'Engineer',
    Id: 169,
    Company_Name: 'HARBOUR ENGINEERING, INC',
    Company_Address: '215 W MAIN ST, STE L-1PLAINFIELD, IL 60601',
  },
  {
    Company_Name: 'ABRASIVE ENGINEERING',
    Company_Address: '135 S LASALLE DEPT  1527CHICAGO, IL 60674-1527',
    Service_Type: 'Engineer',
    Id: 119,
  },
  {
    Id: 185,
    Service_Type: 'Engineer',
    Company_Address: '3434 INDUSTRIAL 33RD STFORT PIERCE, FL 34946',
    Company_Name: 'MATRIX ENGINEERING, INC',
  },
  {
    Id: 83,
    Company_Address: '29047.27, MJC DEMOLITION, INC.13725.00, GREAT LAKES STAIR & STEEL 19350.00',
    Service_Type: 'Contractor',
    Company_Name: 'F & B CONSTRUCTION SERVICES',
  },
  {
    Company_Name: 'CHEMICAL ENGINEERING',
    Id: 135,
    Company_Address: 'PO BOX 507HIGHTSTOWN, NJ',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'GLOBAL ENGINEERING DOCUMENTS',
    Id: 164,
    Company_Address: '15 INVERNESS WAY EASTENGLEWOOD, CO 80112-9660',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 371034PITTSBURGH, PA',
    Company_Name: 'WESTINGHOUSE ELECTRIC CORP. ENGINEERING SERVICES DIVISION',
    Id: 223,
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'DUNNET BAY CONSTRUCTION COMPANY',
    Id: 70,
    Company_Address: '115 N BRANDON DRGLENDALE HEIGHTS, IL 60139',
  },
  {
    Id: 122,
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 95996CHICAGO, IL 60694',
    Company_Name: 'AMCO DIV OF PUMP ENGINEERING',
  },
  {
    Id: 82,
    Company_Name: 'EXECUTIVE CONSTRUCTION INC',
    Service_Type: 'Contractor',
    Company_Address: '235 FENCI LNHILLSIDE, IL 60162',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '111 E WACKER DR STE 2450CHICAGO, IL 60601',
    Id: 25,
    Company_Name: 'BERGLUND CONSTRUCTION COMPANY',
  },
  {
    Service_Type: 'Contractor',
    Id: 2,
    Company_Address: 'PO BOX 66694CHICAGO, IL 60666-0694',
    Company_Name: 'ACE CONSTRUCTION SERVICES',
  },
  {
    Id: 189,
    Service_Type: 'Engineer',
    Company_Name: 'MILHOUSE ENGINEERING & CONSTRUCTION INC.',
    Company_Address: '60 E VAN BUREN EFTCHICAGO, IL 60605',
  },
  {
    Company_Address: 'C/O  LAUREN FIELDS, 1735 NEW YORK AVENUE  NWWASHINGTON, DC 20006',
    Company_Name: 'AMERICAN INSTITUTE OF ARCHITECTURE STUDENTS',
    Id: 100,
    Service_Type: 'Architect',
  },
  {
    Company_Name: 'FOUNDATION ENGINEERING, INC.',
    Company_Address: '3607 CRESTVIEW DRLAKE ZURICH, IL 60047',
    Id: 162,
    Service_Type: 'Engineer',
  },
  {
    Id: 65,
    Company_Address: 'LABORATORIES, INC., 5400 OLD ORCHARD RDSKOKIE, IL 60077-1030',
    Service_Type: 'Contractor',
    Company_Name: 'CONSTRUCTION TECHNOLOGY LABS',
  },
  {
    Company_Name: 'TIOGA ENGINEERING',
    Id: 216,
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 913WELLSBORO, PA 16901',
  },
  {
    Company_Name: 'ATLAS ENGINEERING GROUP LIMITED',
    Id: 127,
    Company_Address: '3100 DUNDEE RDNORTHBROOK, IL 60062',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'EFFECTIVE ENGINEERING INC',
    Service_Type: 'Engineer',
    Id: 152,
    Company_Address: '2805 W EMPIRE AVEBURBANK, CA 91504',
  },
  {
    Company_Name: 'FLUOR ENGINEERING',
    Id: 161,
    Service_Type: 'Engineer',
    Company_Address: '200 W MONROE STCHICAGO, IL 60606',
  },
  {
    Company_Name: 'COBALT COMMERCIAL CONSTRUCTION, LLC.',
    Company_Address: '777 LAKE ZURICH RDBARRINGTON, IL 60010',
    Service_Type: 'Contractor',
    Id: 51,
  },
  {
    Company_Name: 'CERTIFIED MIDWEST CONSTRUCTION',
    Id: 41,
    Company_Address: '6412 W 27TH STBERWYN, IL 60402',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '1114 E 119TH STGLENWOOD, IL 60425',
    Id: 88,
    Company_Name: 'FIRST RANK CONSTRUCTION, INC.',
  },
  {
    Company_Name: 'AMERICAN INSTITUTE OF STEEL CONSTRUCTION',
    Id: 11,
    Service_Type: 'Contractor',
    Company_Address: 'WRIGLEY BLDG P O BOX 806276CHICAGO, IL 60680-4124',
  },
  {
    Company_Name: 'CONSTRUCTION MANAGEMENT ASSOC.',
    Id: 60,
    Company_Address: 'AMERICA-D/B/A-CMAA, 7926 JONES BRAND DR # 800MCLEAN, VA 22102',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'CONSTRUCTION SERVICE ASSOCIATES',
    Company_Address: '166 W WASHINGTON ST # 750CHICAGO, IL 60602',
    Id: 63,
  },
  {
    Id: 200,
    Company_Address: 'LTD, 3575 GRAND AVE STE AGURNEE, IL 60031-3774',
    Company_Name: 'RUDNY & SALLMANN ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'ENVIRONMENTEL SYSTEMS DESIGN CONSTRUCTION, INC',
    Service_Type: 'Contractor',
    Company_Address: '175 W JACKSON BLVD # 1400CHICAGO, IL 60604',
    Id: 78,
  },
  {
    Id: 213,
    Company_Name: 'TEXAS A & M ENGINEERING EXTENSION SERVICE FINANCIAL SERVICES',
    Company_Address: 'PO BOX 40006COLLEGE STATION, TX 77842',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Id: 154,
    Company_Name: 'ENGINEERING & RECORDING SOCIETY OF CHICAGO',
    Company_Address: '1719 S CLINTON STCHICAGO, IL 60616',
  },
  {
    Company_Address: 'PO BOX 517HIGHTSTOWN, NJ',
    Service_Type: 'Engineer',
    Company_Name: 'ENGINEERING NEWS RECORD',
    Id: 156,
  },
  {
    Company_Address: '960 COUNTY LINE RDBENSENVILLE, IL 60106',
    Company_Name: 'DIFRESCO CEMENT CONSTRUCTION',
    Id: 69,
    Service_Type: 'Contractor',
  },
  {
    Id: 112,
    Company_Name: 'PAMELA SELF LANDSCAPE ARCHITECTURE LIMITED',
    Company_Address: 'ONE ANNE COURTHAWTHORN WOODS, IL 60047',
    Service_Type: 'Architect',
  },
  {
    Company_Address: '2 PIERCE PLITASCA, IL 60143',
    Service_Type: 'Engineer',
    Company_Name: 'CIVILTECH ENGINEERING INC',
    Id: 138,
  },
  {
    Id: 121,
    Service_Type: 'Engineer',
    Company_Address: '1401 NORFOLK STDOWNERS GROVE, IL 60516',
    Company_Name: 'ALPHA ENGINEERING SERVICES',
  },
  {
    Company_Name: 'ENGINEERING SYSTEMS INC/ESI',
    Id: 158,
    Service_Type: 'Engineer',
    Company_Address: '3851 EXCHANGE AVEAURORA, IL 60504',
  },
  {
    Company_Name: 'LANDSCAPE ARCHITECTURE',
    Id: 110,
    Company_Address: '636 I ST. NWWASHINGTON, DC 20001',
    Service_Type: 'Architect',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: 'CONTROLS, INC., 12225 DISK DRLOCKPORT, IL 60441',
    Company_Name: 'ALTERNATE CONSTRUCTION CONTROLS, INC.',
    Id: 9,
  },
  {
    Company_Name: 'BIG JOHN CONSTRUCTION',
    Service_Type: 'Contractor',
    Id: 26,
    Company_Address: '9909 W ROOSEVELT # 208-BWESTCHESTER, IL 60154',
  },
  {
    Id: 45,
    Company_Address: 'SAFETY COUNCIL, 4100 MADISON STHILLSIDE, IL 60162',
    Company_Name: 'CHICAGOLAND CONSTRUCTION 01',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'CASTLE CONSTRUCTION CORPORATION.',
    Service_Type: 'Contractor',
    Id: 39,
    Company_Address: '3062 W 167TH STMARKHAM, IL 60426-5618',
  },
  {
    Id: 131,
    Company_Address: 'PO BOX 40729INDIANAPOLIS, IN 46240',
    Company_Name: 'BOWEN ENGINEERING CORP',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'ALPHA ENGINEERING SERVICES',
    Id: 121,
    Company_Address: '1401 NORFOLK STDOWNERS GROVE, IL 60516',
  },
  {
    Company_Address: '4403 W LAWRENCE AVE STE 205  EFTCHICAGO, IL 60630',
    Id: 47,
    Company_Name: 'CITY CONSTRUCTION COMPANY INC.',
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '1550 S INDIANA AVECHICAGO, IL 60605',
    Company_Name: "CONSTRUCTION & GENRAL LABORS'",
    Id: 54,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '6702 FOREST VIEW LANENILES, IL 60714',
    Company_Name: 'J & S TOOL & ENGINEERING CO INC',
    Id: 176,
    Service_Type: 'Engineer',
  },
  {
    Id: 64,
    Service_Type: 'Contractor',
    Company_Address: '99 CANAL CENTER PLZ STE 300ALEXANDRIA, VA 22314',
    Company_Name: 'CONSTRUCTION SPECIFICATION',
  },
  {
    Company_Address: '15 INVERNESS WAY EASTENGLEWOOD, CO 80112-9660',
    Service_Type: 'Engineer',
    Company_Name: 'GLOBAL ENGINEERING DOCUMENTS',
    Id: 164,
  },
  {
    Company_Address: '1445 OAKTON STELK GROVE VILLAGE, IL 60007',
    Id: 13,
    Service_Type: 'Contractor',
    Company_Name: 'ARROW ROAD CONSTRUCTION COMPANY',
  },
  {
    Company_Address: '636 I ST. NWWASHINGTON, DC 20001',
    Company_Name: 'LANDSCAPE ARCHITECTURE',
    Id: 110,
    Service_Type: 'Architect',
  },
  {
    Service_Type: 'Contractor',
    Id: 45,
    Company_Address: 'SAFETY COUNCIL, 4100 MADISON STHILLSIDE, IL 60162',
    Company_Name: 'CHICAGOLAND CONSTRUCTION 01',
  },
  {
    Id: 76,
    Company_Name: 'ELLIS CONSTRUCTION',
    Service_Type: 'Contractor',
    Company_Address: '8641 S VINCENNES AVECHICAGO, IL 60620',
  },
  {
    Id: 128,
    Company_Name: 'BARKER LEMAR ENGINEERING CONSULTANTS',
    Service_Type: 'Engineer',
    Company_Address: '1801 INDUSTRIAL CIRWEST DES MOINES, IA 50265',
  },
  {
    Company_Name: 'FIRE ENGINEERING',
    Company_Address: 'PO BOX 1289TULSA, OK 74101',
    Id: 160,
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '6577 N AVONDALE AVECHICAGO, IL 60631',
    Service_Type: 'Contractor',
    Id: 33,
    Company_Name: 'BROADWAY CONSTRUCTION, INC',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '6436 W HIGGINS AVENUE EFTCHICAGO, IL 60656',
    Id: 191,
    Company_Name: 'PAN-OCEANIC ENGINEERING CO INC',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 5564BUFFALO GROVE, IL 60089',
    Company_Name: 'SCHIRMER ENGINEERING CORP',
    Id: 203,
  },
  {
    Company_Address: '921 W VAN BUREN ST STE 100CHICAGO, IL 60607',
    Company_Name: 'HBK ENGINEERING, LLC',
    Service_Type: 'Engineer',
    Id: 170,
  },
  {
    Company_Address: 'DEPT# 1501DENVER, CO 80291-2721',
    Service_Type: 'Engineer',
    Company_Name: 'GLOBAL ENGINEERING DOCUMENTS',
    Id: 165,
  },
  {
    Id: 5,
    Company_Name: 'ALBERT WENDT CONSTRUCTION CO',
    Company_Address: '21 W 180 HILL AVEGLEN ELLYN, IL 60137',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Id: 27,
    Company_Name: 'BIGANE PAVING C/O PLOTE CONSTRUCTION INC JV',
    Company_Address: '935 W CHESTNUT STREET EFTCHICAGO, IL 60642',
  },
  {
    Company_Address: '1325 EAST PARK STTAYLORVILLE, IL 62568',
    Service_Type: 'Contractor',
    Id: 14,
    Company_Name: 'B & R CONSTRUCTION INC',
  },
  {
    Service_Type: 'Contractor',
    Id: 41,
    Company_Name: 'CERTIFIED MIDWEST CONSTRUCTION',
    Company_Address: '6412 W 27TH STBERWYN, IL 60402',
  },
  {
    Service_Type: 'Architect',
    Company_Name: 'UIC-SCHOOL OF ARCHITECTURE',
    Id: 114,
    Company_Address: '845 W HARRISON STCHICAGO, IL 60607-7024',
  },
  {
    Company_Address: '238 S KENILWORTH AVEOAK PARK, IL 60302',
    Id: 215,
    Service_Type: 'Engineer',
    Company_Name: 'THOMAS ENGINEERING GROUP, LLC.',
  },
  {
    Company_Address: '200 S MICHIGAN AVENUE EFTCHICAGO, IL 60604',
    Id: 116,
    Service_Type: 'Architect',
    Company_Name: 'YAS ARCHITECTURE LLC',
  },
  {
    Company_Name: 'STONE & WEBSTER ENGINEERING',
    Company_Address: 'PO BOX 1611BOSTON, MA',
    Id: 209,
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Contractor',
    Id: 68,
    Company_Address: '4125 S EMERALD AVE FL 1STCHICAGO, IL 60609',
    Company_Name: 'DEVRO CONSTRUCTION CO',
  },
  {
    Company_Address: '2323 W NELSON STCHICAGO, IL 60618',
    Company_Name: 'DEPENDABLE CONSTRUCTION COMPANY, INC.N',
    Id: 67,
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '3209 OLD HIGGINSELK GROVE VILLAGE, IL 60007',
    Id: 90,
    Company_Name: 'FLEX CONSTRUCTION CORP',
  },
  {
    Company_Address: '16913 ENTERPRISE DRFOUNTAIN HILLS, AZ 85269-7480',
    Service_Type: 'Architect',
    Company_Name: 'ARCHITECTURE, CIRCULATION DEPARTMENT',
    Id: 101,
  },
  {
    Id: 124,
    Company_Address: '1775 CORTLAND CT  CADDISON, IL 60101',
    Service_Type: 'Engineer',
    Company_Name: 'AMERICAN GEO ENGINEERING, INC.',
  },
  {
    Company_Address: '2901 CRESCENT DRTALLAHASSEE, FL 32301-3535',
    Service_Type: 'Engineer',
    Company_Name: 'TRAK ENGINEERING INC',
    Id: 217,
  },
  {
    Company_Name: 'CLARK CONSTRUCTION/ MCHUGH/',
    Company_Address: 'RAUSCH J/V, 216 S JEFFERSON STCHICAGO, IL 60661',
    Id: 48,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '29047.27, MJC DEMOLITION, INC.13725.00, GREAT LAKES STAIR & STEEL 19350.00',
    Service_Type: 'Contractor',
    Company_Name: 'F & B CONSTRUCTION SERVICES',
    Id: 83,
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '4810 MARQUETTE AVE NEALBUQUERQUE, NM 87108',
    Company_Name: 'COMPUTER AUDIO ENGINEERING',
    Id: 144,
  },
  {
    Id: 106,
    Service_Type: 'Architect',
    Company_Name: 'FARR ASSOCIATES, ARCHITECTURE & URBAN DESIGN, INC',
    Company_Address: '& URBAN DESIGN, 53 W JACKSON BLVD STE 650CHICAGO, IL 60604',
  },
  {
    Id: 157,
    Company_Address: '4260 WESTBROOK DRAURORA, IL 60504',
    Company_Name: 'ENGINEERING SERVICES GROUP, INC.',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '8501 W HIGGINS RD STE 320CHICAGO, IL 60631',
    Id: 29,
    Service_Type: 'Contractor',
    Company_Name: 'BLINDERMAN CONSTRUCTION COMPANY, INC.',
  },
  {
    Service_Type: 'Engineer',
    Id: 198,
    Company_Name: 'RONAN ENGINEERING COMPANY',
    Company_Address: 'PO BOX 1275WOODLAND HILLS, CA 91365',
  },
  {
    Company_Address: '371 S EVERGREEN STREET EFTBENSENVILLE, IL 60106',
    Service_Type: 'Contractor',
    Id: 95,
    Company_Name: 'G & V CONSTRUCTION CO INC',
  },
  {
    Service_Type: 'Engineer',
    Id: 120,
    Company_Name: 'AEROTEC ENGINEERING & CONS INC',
    Company_Address: 'PO BOX 456PARK RIDGE, IL 60068',
  },
  {
    Id: 97,
    Company_Name: 'GANNA CONSTRUCTION CO',
    Service_Type: 'Contractor',
    Company_Address: '1 PIERCE PL # 250-CITASCA, IL 60143-1253',
  },
  {
    Company_Name: 'BECKLEY ENGINEERING INC',
    Company_Address: '343 DANIELLE RDMATTESON, IL 60443',
    Service_Type: 'Engineer',
    Id: 129,
  },
  {
    Company_Name: 'SCHIRMER ENGINEERING CORP.',
    Id: 204,
    Company_Address: '707 LAKE COOK RDDEERFIELD, IL 60015-4997',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'J.V. CRANE & ENGINEERING, INC.',
    Id: 177,
    Company_Address: '425 S SHELBY STHOBART, IN 46342',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'ENGINEERING SYSTEMS INC/ESI',
    Company_Address: '3851 EXCHANGE AVEAURORA, IL 60504',
    Service_Type: 'Engineer',
    Id: 158,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'AAA ENGINEERING',
    Company_Address: '2942 W JARLATH STCHICAGO, IL 60645',
    Id: 117,
  },
  {
    Company_Address: '579 N FIRST BANK DR STE 220PALATINE, IL 60067',
    Company_Name: 'CONSTRUCTION BUSINESS MEDIA LL',
    Service_Type: 'Contractor',
    Id: 56,
  },
  {
    Company_Name: 'JB ENGINEERING & CODE CONSULT.',
    Company_Address: '1661 CARDINAL DRMUNSTER, IN 46321',
    Id: 179,
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'CAPITAL CONSTRUCTION GROUP INC',
    Service_Type: 'Contractor',
    Company_Address: '123 N WACKER DRCHICAGO, IL 60606',
    Id: 38,
  },
  {
    Service_Type: 'Contractor',
    Id: 61,
    Company_Address: '2072 W PALATINE RDPALATINE, IL 60067',
    Company_Name: 'CONSTRUCTION SAFETY & CHEMICAL SOLUTIONS',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'BECAN CONSTRUCTION CO. OF ILLINOIS., INC',
    Company_Address: '4335 S WESTERN AVECHICAGO, IL 60609',
    Id: 19,
  },
  {
    Service_Type: 'Engineer',
    Id: 167,
    Company_Address: 'PO BOX 185CENTERVILLE, IN 47330',
    Company_Name: 'GOLDEN ENGINEERING',
  },
  {
    Company_Name: 'INTERNATIONAL ENGINEERING CONSULTANTS, INC.',
    Service_Type: 'Engineer',
    Id: 175,
    Company_Address: 'CONSULTANTS, INC., 188 W RANDOLPH ST STE 1826CHICAGO, IL 60601',
  },
  {
    Company_Name: 'CHICAGO ARCHITECTURE.FOUNDATION, INC.',
    Id: 104,
    Company_Address: '224 S MICHIGAN AVE FL 1STCHICAGO, IL 60604-2500',
    Service_Type: 'Architect',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'FASTENAL IND & CONSTRUCTION',
    Company_Address: '1200 W CERMAK RDCHICAGO, IL 60608',
    Id: 84,
  },
  {
    Id: 225,
    Service_Type: 'Engineer',
    Company_Address: '2301 W 22ND ST STE 209OAK BROOK, IL 60523',
    Company_Name: 'XEROX ENGINEERING SYSTEMS',
  },
  {
    Id: 199,
    Company_Address: 'PO BOX 708SEDRO WOOLLEY, WA 98284',
    Company_Name: 'ROTHENBUHLER ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'CLEAN WORLD ENGINEERING, LIMITED',
    Service_Type: 'Engineer',
    Id: 140,
    Company_Address: '1737 S NAPERVILLE RD # 200WHEATON, IL 60187-8100',
  },
  {
    Company_Name: 'COMPUTER AUDIO ENGINEERING',
    Id: 144,
    Company_Address: '4810 MARQUETTE AVE NEALBUQUERQUE, NM 87108',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '15485.81CHICAGO, IL',
    Service_Type: 'Engineer',
    Id: 166,
    Company_Name: 'GLOBETROTTERS ENGINEERING CORP',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'BEAR CONSTRUCTION',
    Id: 18,
    Company_Address: '1 N LA SALLE ST STE 2700CHICAGO, IL 60602',
  },
  {
    Id: 81,
    Company_Name: 'EXCLUSIVE CONSTRUCTION SERVICE',
    Service_Type: 'Contractor',
    Company_Address: '1005 W GRAND AVECHICAGO, IL 60622',
  },
  {
    Service_Type: 'Engineer',
    Id: 150,
    Company_Address: '444 LAKE C OOK RDDEERFIELD, IL 60015',
    Company_Name: 'EA ENGINEERING & TECHNOLOGY',
  },
  {
    Company_Name: 'BLINDERMAN CONSTRUCTION COMPANY, INC.',
    Service_Type: 'Contractor',
    Company_Address: '8501 W HIGGINS RD STE 320CHICAGO, IL 60631',
    Id: 29,
  },
  {
    Id: 122,
    Company_Name: 'AMCO DIV OF PUMP ENGINEERING',
    Company_Address: 'PO BOX 95996CHICAGO, IL 60694',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'APEX ENGINEERING PRODUCTS CORPORATION',
    Company_Address: '1241 SHORELINE DRAURORA, IL 60504',
    Id: 125,
    Service_Type: 'Engineer',
  },
  {
    Id: 69,
    Company_Address: '960 COUNTY LINE RDBENSENVILLE, IL 60106',
    Service_Type: 'Contractor',
    Company_Name: 'DIFRESCO CEMENT CONSTRUCTION',
  },
  {
    Company_Name: 'DIGITAL ENGINEERING CORP.',
    Company_Address: '125 CATHEDRAL STANNAPOLIS, MD 21401',
    Id: 148,
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '700 INDUSTRIAL DR STE 1-WBENSENVILLE, IL 60106',
    Company_Name: 'D & F ENGINEERING, INC.',
    Service_Type: 'Engineer',
    Id: 145,
  },
  {
    Company_Name: 'ENGLEWOOD CONSTRUCTION CO.,INC',
    Id: 77,
    Company_Address: 'PO BOX 439183CHICAGO, IL 60643-9183',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'FERRO & DIPIAZZA CONSTRUCTION INC',
    Company_Address: '3611 S NORMAL AVECHICAGO, IL 60609',
    Id: 86,
  },
  {
    Company_Address: '330 N WABASH AVE # 3200OAK BROOK, IL 60611',
    Id: 208,
    Company_Name: 'SHAH ENGINEERING, INC.',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'E. KING CONSTRUCTION COMP., INC.',
    Company_Address: '3865 W COLUMBUS AVECHICAGO, IL 60652',
    Id: 71,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'PIONEER ENGINEERING & ENVIRONMENTAL SERVICES, LLC',
    Id: 193,
    Company_Address: '700 N SACRAMENTO BOULEVARD EFTCHICAGO, IL 60612',
  },
  {
    Id: 90,
    Service_Type: 'Contractor',
    Company_Name: 'FLEX CONSTRUCTION CORP',
    Company_Address: '3209 OLD HIGGINSELK GROVE VILLAGE, IL 60007',
  },
  {
    Company_Name: 'YAS ARCHITECTURE LLC',
    Service_Type: 'Architect',
    Company_Address: '200 S MICHIGAN AVENUE EFTCHICAGO, IL 60604',
    Id: 116,
  },
  {
    Id: 115,
    Service_Type: 'Architect',
    Company_Name: 'WOLFF LANDSCAPE ARCHITECTURE',
    Company_Address: '307 N MICHIGAN AVE STE 601CHICAGO, IL 60601',
  },
  {
    Company_Name: 'BECKLEY ENGINEERING INC',
    Service_Type: 'Engineer',
    Id: 129,
    Company_Address: '343 DANIELLE RDMATTESON, IL 60443',
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'WESTINGHOUSE ELECTRIC CORP. ENGINEERING SERVICES DIVISION',
    Id: 223,
    Company_Address: 'PO BOX 371034PITTSBURGH, PA',
  },
  {
    Id: 185,
    Company_Address: '3434 INDUSTRIAL 33RD STFORT PIERCE, FL 34946',
    Company_Name: 'MATRIX ENGINEERING, INC',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '1001 N MILWAUKEE AVECHICAGO, IL 60642',
    Service_Type: 'Contractor',
    Id: 93,
    Company_Name: 'FRIEDLER CONSTRUCTION CO',
  },
  {
    Company_Address: '663 ACADEMY DRNORTHBROOK, IL 60062-2420',
    Company_Name: 'COMMERCIAL ENGINEERING CORP.',
    Service_Type: 'Engineer',
    Id: 142,
  },
  {
    Id: 177,
    Company_Name: 'J.V. CRANE & ENGINEERING, INC.',
    Company_Address: '425 S SHELBY STHOBART, IN 46342',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'TERRA ENGINEERING',
    Id: 212,
    Company_Address: '225 W OHIO ST FL 4THCHICAGO, IL 60654',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '2021 MIDWEST RD STE 204HINSDALE, IL 60521',
    Service_Type: 'Engineer',
    Company_Name: 'T ENGINEERING SERVICE LIMITED',
    Id: 210,
  },
  {
    Company_Name: 'BUSINESS SYSTEMS ENGINEERING',
    Company_Address: '6 W HUBBARD ST FL 2NDCHICAGO, IL 60610',
    Id: 134,
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '6959 MILWAUKEE AVENILES, IL 60714',
    Company_Name: 'EDISON CONSTRUCTION CO',
    Id: 75,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '400 OSER AVEHAUPPAUGE, NY 11788',
    Company_Name: 'CONSTRUCTION DATA SERVICES',
    Service_Type: 'Contractor',
    Id: 59,
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '1015 15TH ST NWWASHINGTON, DC 20005',
    Company_Name: 'AMERICAN COUNCIL OF ENGINEERING COMPANIES',
    Id: 123,
  },
  {
    Company_Name: 'JB ENGINEERING & CODE CONSULT.',
    Id: 179,
    Service_Type: 'Engineer',
    Company_Address: '1661 CARDINAL DRMUNSTER, IN 46321',
  },
  {
    Id: 222,
    Company_Address: '303 W MADISON ST, 2100CHICAGO, IL 60601',
    Company_Name: 'WESTIN ENGINEERING INC',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'ALCO CONSTRUCTION COMPANY INC',
    Company_Address: '3608 N MILWAUKEE AVE # 1CHICAGO, IL 60641',
    Service_Type: 'Contractor',
    Id: 6,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'AMERICAN GEO ENGINEERING, INC.',
    Company_Address: '1775 CORTLAND CT  CADDISON, IL 60101',
    Id: 124,
  },
  {
    Id: 141,
    Company_Address: '2021 MIDWEST RDHINSDALE, IL 60521-1342',
    Company_Name: 'CODE ENGINEERING SERVICES',
    Service_Type: 'Engineer',
  },
  {
    Id: 57,
    Service_Type: 'Contractor',
    Company_Address: '5410 S STATE STREET EFTCHICAGO, IL 60609',
    Company_Name: 'CONSTRUCTION CAREERS COUNCIL',
  },
  {
    Company_Name: 'TRIMCO MANUFACTURING & ENGINEERING INC',
    Company_Address: '309 LINCOLN STBENSENVILLE, IL 60106',
    Id: 218,
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'BLUE RIBBON CONSTRUCTION',
    Id: 30,
    Company_Address: 'CONSTRUCTION, 3551 W 111TH STCHICAGO, IL 60655',
    Service_Type: 'Contractor',
  },
  {
    Id: 159,
    Company_Name: 'EXPLICO ENGINEERING',
    Service_Type: 'Engineer',
    Company_Address: '40028 GRAND RIVER AVE  STE300NOVI, MI 48375',
  },
  {
    Company_Address: '145 TOWER DRBURR RIDGE, IL 60527',
    Service_Type: 'Contractor',
    Id: 8,
    Company_Name: 'ALL-BRY CONSTRUCTION COMPANY',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '2323 W NELSON STCHICAGO, IL 60618',
    Company_Name: 'DEPENDABLE CONSTRUCTION COMPANY, INC.N',
    Id: 67,
  },
  {
    Id: 207,
    Company_Name: 'SETON ENGINEERING',
    Service_Type: 'Engineer',
    Company_Address: '19 S BOTHWELL STPALATINE, IL 60067-5010',
  },
  {
    Company_Address: '2798 S FISH HATCHERY RDMADISON, WI 53711-5398',
    Id: 201,
    Company_Name: 'SAFETY ENGINEERING ASSOCIATES.',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '517 W 97TH STCHICAGO, IL 60628-1115',
    Id: 72,
    Service_Type: 'Contractor',
    Company_Name: 'E.B.T CONSTRUCTION INC.',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: 'CONSTRUCTION COMPANY, 4545 S WESTERN BLVD # 2-BCHICAGO, IL 60609',
    Company_Name: "FLYNN'S CORNERSTONE CONSTRUCTION COMPANY",
    Id: 91,
  },
  {
    Service_Type: 'Engineer',
    Id: 196,
    Company_Name: 'QUANTUM ENGINEERING CORPORATION',
    Company_Address: '602 CAMDEN LNPORT BARRINGTON, IL 60010',
  },
  {
    Company_Name: 'C3 CONSTRUCTION SERVICES INC',
    Service_Type: 'Contractor',
    Company_Address: '5824 W 83RD STBURBANK, IL 60459',
    Id: 36,
  },
  {
    Company_Address: '1445 OAKTON STELK GROVE VILLAGE, IL 60007',
    Id: 13,
    Service_Type: 'Contractor',
    Company_Name: 'ARROW ROAD CONSTRUCTION COMPANY',
  },
  {
    Id: 94,
    Service_Type: 'Contractor',
    Company_Address: '5239 W DIVERSEY AVECHICAGO, IL 60639',
    Company_Name: 'G & V CONSTRUCTION CO INC',
  },
  {
    Id: 6,
    Company_Name: 'ALCO CONSTRUCTION COMPANY INC',
    Company_Address: '3608 N MILWAUKEE AVE # 1CHICAGO, IL 60641',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'CONSTRUCTION CAREERS COUNCIL',
    Company_Address: '5410 S STATE STCHICAGO, IL 60609',
    Service_Type: 'Contractor',
    Id: 58,
  },
  {
    Company_Name: 'CONSORTIUM FOR DESIGN & CONSTRUCTION CAREERS',
    Company_Address: '150 S WACKER DR STE 1900CHICAGO, IL 60606',
    Id: 52,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '650 PIERCE BLVDO FALLON, IL 62269',
    Id: 205,
    Service_Type: 'Engineer',
    Company_Name: 'SCI ENGINEERING INC',
  },
  {
    Company_Address: '1737 S NAPERVILLE RD # 200WHEATON, IL 60187-8100',
    Service_Type: 'Engineer',
    Id: 140,
    Company_Name: 'CLEAN WORLD ENGINEERING, LIMITED',
  },
  {
    Company_Name: 'VIKING ENGINEERING COMPANY, INC',
    Service_Type: 'Engineer',
    Id: 221,
    Company_Address: 'COMPANY, INC, 2300 MICHIGAN STHAMMOND, IN 46320',
  },
  {
    Id: 138,
    Service_Type: 'Engineer',
    Company_Address: '2 PIERCE PLITASCA, IL 60143',
    Company_Name: 'CIVILTECH ENGINEERING INC',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '1713 CATRON CT SEALBUQUERQUE, NM 87123',
    Id: 136,
    Company_Name: 'CHERRY ENGINEERING INC',
  },
  {
    Id: 87,
    Company_Name: 'FERRO CONSTRUCTION COMPANY.INC',
    Service_Type: 'Contractor',
    Company_Address: '12100 S MARSHFIELD AVE, # 6CALUMET PARK, IL 60632',
  },
  {
    Company_Name: 'CONSTRUCTION',
    Id: 53,
    Service_Type: 'Contractor',
    Company_Address: 'SPECIFICATIONS INSTITUTE, 601 MADISON STALEXANDRIA, VA 22314-1791',
  },
  {
    Company_Address: '8641 S VINCENNES AVECHICAGO, IL 60620',
    Service_Type: 'Contractor',
    Id: 76,
    Company_Name: 'ELLIS CONSTRUCTION',
  },
  {
    Company_Address: '777 LAKE ZURICH RDBARRINGTON, IL 60010',
    Company_Name: 'COBALT COMMERCIAL CONSTRUCTION, LLC.',
    Id: 51,
    Service_Type: 'Contractor',
  },
  {
    Id: 111,
    Company_Name: 'NATHAN KIPNIS ARCHITECTURE,INC',
    Company_Address: '626 GROVE STEVANSTON, IL 60201',
    Service_Type: 'Architect',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'BERGLUND CONSTRUCTION',
    Company_Address: '8410 S CHICAGO AVECHICAGO, IL 60617',
    Id: 23,
  },
  {
    Company_Name: 'FIRE ENGINEERING',
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 1289TULSA, OK 74101',
    Id: 160,
  },
  {
    Id: 17,
    Company_Name: 'BAYWOOD CONSTRUCTION CO',
    Company_Address: '6215 N FOREST GLEN AVECHICAGO, IL 60646',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'HBK ENGINEERING, LLC',
    Id: 170,
    Company_Address: '921 W VAN BUREN ST STE 100CHICAGO, IL 60607',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '303 W MADISON ST, 2100CHICAGO, IL 60601',
    Id: 222,
    Company_Name: 'WESTIN ENGINEERING INC',
  },
  {
    Company_Name: 'AKMA CONSTRUCTION CO, INC.',
    Id: 3,
    Service_Type: 'Contractor',
    Company_Address: 'PO BOX 12328CHICAGO, IL 60612',
  },
  {
    Company_Address: '30 OSER AVE STE 500HAUPPAUGE, NY 11788',
    Company_Name: 'CBE CONSTRUCTION BOOK EXPRESS',
    Id: 40,
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'BEAR CONSTRUCTION',
    Id: 18,
    Service_Type: 'Contractor',
    Company_Address: '1 N LA SALLE ST STE 2700CHICAGO, IL 60602',
  },
  {
    Id: 49,
    Company_Address: '10 S LA SALLE ST STE 300CHICAGO, IL 60603',
    Company_Name: 'CLUNE CONSTRUCTION COMPANY',
    Service_Type: 'Contractor',
  },
  {
    Id: 208,
    Company_Address: '330 N WABASH AVE # 3200OAK BROOK, IL 60611',
    Company_Name: 'SHAH ENGINEERING, INC.',
    Service_Type: 'Engineer',
  },
  {
    Id: 104,
    Service_Type: 'Architect',
    Company_Address: '224 S MICHIGAN AVE FL 1STCHICAGO, IL 60604-2500',
    Company_Name: 'CHICAGO ARCHITECTURE.FOUNDATION, INC.',
  },
  {
    Company_Name: 'ENGINEERING & RECORDING SOCIETY OF CHICAGO',
    Company_Address: '1719 S CLINTON STCHICAGO, IL 60616',
    Id: 154,
    Service_Type: 'Engineer',
  },
  {
    Id: 25,
    Company_Name: 'BERGLUND CONSTRUCTION COMPANY',
    Company_Address: '111 E WACKER DR STE 2450CHICAGO, IL 60601',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Engineer',
    Id: 178,
    Company_Address: '800 MARKET STSAINT LOUIS, MO 63150-8713',
    Company_Name: 'JACOBS ENGINEERING GROUP INC',
  },
  {
    Company_Address: '444 LAKE C OOK RDDEERFIELD, IL 60015',
    Company_Name: 'EA ENGINEERING & TECHNOLOGY',
    Id: 150,
    Service_Type: 'Engineer',
  },
  {
    Id: 136,
    Company_Name: 'CHERRY ENGINEERING INC',
    Service_Type: 'Engineer',
    Company_Address: '1713 CATRON CT SEALBUQUERQUE, NM 87123',
  },
  {
    Company_Address: '307 N MICHIGAN AVE STE 601CHICAGO, IL 60601',
    Service_Type: 'Architect',
    Company_Name: 'WOLFF LANDSCAPE ARCHITECTURE',
    Id: 115,
  },
  {
    Company_Name: 'GLOBETROTTERS ENGINEERING CORP',
    Company_Address: '15485.81CHICAGO, IL',
    Id: 166,
    Service_Type: 'Engineer',
  },
  {
    Id: 46,
    Service_Type: 'Contractor',
    Company_Name: 'CHICAGOLAND CONSTRUCTION, INC.',
    Company_Address: '950 N VILLA AVEVILLA PARK, IL 60181',
  },
  {
    Company_Address: '3056 WEBER DRAURORA, IL',
    Company_Name: 'UNIFIED ENGINEERING, INC',
    Id: 220,
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'BERGLUND CONSTRUCTION',
    Company_Address: '8410 S CHICAGO AVECHICAGO, IL 60617',
    Id: 23,
  },
  {
    Company_Name: 'WHELEN ENGINEERING COMPANY',
    Company_Address: 'WINTHROP ROAD ROUTE 145CHESTER, CT',
    Service_Type: 'Engineer',
    Id: 224,
  },
  {
    Company_Address: 'CONTRACT BOND CLAIMS MGMT INC., 618 CLEARVIEW DRGLENVIEW, IL 60025',
    Id: 1,
    Service_Type: 'Contractor',
    Company_Name: 'A&K CONSTRUCTION CO, INC. C\\/O',
  },
  {
    Company_Name: 'FELIX.CARDONA. CONSTRUCTION',
    Id: 85,
    Service_Type: 'Contractor',
    Company_Address: '2630 N MILWAUKEE AVECHICAGO, IL 60647',
  },
  {
    Company_Name: 'TECHKNOW ENGINEERING, LLC',
    Id: 211,
    Service_Type: 'Engineer',
    Company_Address: '30 E ADAMS ST STE 1100CHICAGO, IL 60603',
  },
  {
    Company_Address: '11 E MADISON ST # 300CHICAGO, IL 60606',
    Service_Type: 'Architect',
    Company_Name: 'GENSLER ARCHITECTURE P C',
    Id: 107,
  },
  {
    Company_Name: 'SEATTLE ENGINEERING DEPT.',
    Company_Address: '410 MUNICIPAL BUILDING, 600 FOURTH AVESEATTLE, WA 98104',
    Id: 206,
    Service_Type: 'Engineer',
  },
  {
    Id: 77,
    Company_Address: 'PO BOX 439183CHICAGO, IL 60643-9183',
    Company_Name: 'ENGLEWOOD CONSTRUCTION CO.,INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '546 W WASHINGTON BLVDCHICAGO, IL 60606',
    Company_Name: 'THATCHER ENGINEERING CORP',
    Service_Type: 'Engineer',
    Id: 214,
  },
  {
    Company_Address: '3100 DUNDEE RDNORTHBROOK, IL 60062',
    Service_Type: 'Engineer',
    Company_Name: 'ATLAS ENGINEERING GROUP LIMITED',
    Id: 127,
  },
  {
    Company_Name: 'EDISON CONSTRUCTION CO',
    Id: 75,
    Service_Type: 'Contractor',
    Company_Address: '6959 MILWAUKEE AVENILES, IL 60714',
  },
  {
    Id: 20,
    Company_Address: 'PO BOX 277  EFTTINLEY PARK, IL 60477',
    Service_Type: 'Contractor',
    Company_Name: 'BECHSTEIN CONSTRUCTION CORP',
  },
  {
    Id: 141,
    Service_Type: 'Engineer',
    Company_Name: 'CODE ENGINEERING SERVICES',
    Company_Address: '2021 MIDWEST RDHINSDALE, IL 60521-1342',
  },
  {
    Company_Name: 'DIGITAL ENGINEERING CORP.',
    Company_Address: '125 CATHEDRAL STANNAPOLIS, MD 21401',
    Id: 148,
    Service_Type: 'Engineer',
  },
  {
    Id: 206,
    Company_Name: 'SEATTLE ENGINEERING DEPT.',
    Company_Address: '410 MUNICIPAL BUILDING, 600 FOURTH AVESEATTLE, WA 98104',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'DELTA ENGINEERING GROUP LLC',
    Service_Type: 'Engineer',
    Id: 146,
    Company_Address: '111 W JACKSON BLVD STE 910CHICAGO, IL 60604',
  },
  {
    Id: 199,
    Company_Address: 'PO BOX 708SEDRO WOOLLEY, WA 98284',
    Service_Type: 'Engineer',
    Company_Name: 'ROTHENBUHLER ENGINEERING',
  },
  {
    Id: 38,
    Company_Name: 'CAPITAL CONSTRUCTION GROUP INC',
    Company_Address: '123 N WACKER DRCHICAGO, IL 60606',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'BENCHMARK CONSTRUCTION CO. INC',
    Company_Address: '3349 S KEDZIE AVENUE EFTCHICAGO, IL 60623',
    Service_Type: 'Contractor',
    Id: 22,
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '235 FENCI LNHILLSIDE, IL 60162',
    Company_Name: 'EXECUTIVE CONSTRUCTION INC',
    Id: 82,
  },
  {
    Company_Address: 'LABORATORIES, INC., 5400 OLD ORCHARD RDSKOKIE, IL 60077-1030',
    Id: 65,
    Service_Type: 'Contractor',
    Company_Name: 'CONSTRUCTION TECHNOLOGY LABS',
  },
  {
    Company_Name: 'INFRASTRUCTURE ENGINEERING INC',
    Service_Type: 'Engineer',
    Id: 173,
    Company_Address: '1 S WACKER DR STE 2650CHICAGO, IL 60606',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'BOLLER CONSTRUCTION COMPANY INC',
    Company_Address: '3045 W WASHINGTON STWAUKEGAN, IL 60085',
    Id: 32,
  },
  {
    Company_Address: 'WRIGLEY BLDG P O BOX 806276CHICAGO, IL 60680-4124',
    Service_Type: 'Contractor',
    Id: 11,
    Company_Name: 'AMERICAN INSTITUTE OF STEEL CONSTRUCTION',
  },
  {
    Id: 155,
    Company_Name: 'ENGINEERING ANSWERS INC',
    Service_Type: 'Engineer',
    Company_Address: '420 N MAIN STMONTGOMERY, IL 60538',
  },
  {
    Company_Name: 'JACOBS ENGINEERING GROUP INC',
    Id: 178,
    Company_Address: '800 MARKET STSAINT LOUIS, MO 63150-8713',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '16913 ENTERPRISE DRFOUNTAIN HILLS, AZ 85269-7480',
    Service_Type: 'Architect',
    Id: 101,
    Company_Name: 'ARCHITECTURE, CIRCULATION DEPARTMENT',
  },
  {
    Service_Type: 'Contractor',
    Id: 64,
    Company_Address: '99 CANAL CENTER PLZ STE 300ALEXANDRIA, VA 22314',
    Company_Name: 'CONSTRUCTION SPECIFICATION',
  },
  {
    Company_Name: 'B&B CONSTRUCTION & EXCAVATING',
    Service_Type: 'Contractor',
    Company_Address: '1288 E BUNGALOW RDMORRIS, IL 60450',
    Id: 15,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'UNIFIED ENGINEERING, INC',
    Id: 220,
    Company_Address: '3056 WEBER DRAURORA, IL',
  },
  {
    Company_Name: 'CONSTRUCTION ADVANCEMENT FOUND',
    Id: 55,
    Company_Address: '6050 SOUTHPORT RD STE APORTAGE, IN 46368',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'CHICAGO ARCHITECTURE FOUNDATION',
    Company_Address: '111 E WACKER DR STE 1321CHICAGO, IL 60601',
    Id: 103,
    Service_Type: 'Architect',
  },
  {
    Id: 89,
    Company_Address: '9820 CASH RDSTAFFORD, TX 77477-4423',
    Company_Name: 'FISH CONSTRUCTION, INC.',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Id: 71,
    Company_Address: '3865 W COLUMBUS AVECHICAGO, IL 60652',
    Company_Name: 'E. KING CONSTRUCTION COMP., INC.',
  },
  {
    Id: 30,
    Company_Name: 'BLUE RIBBON CONSTRUCTION',
    Service_Type: 'Contractor',
    Company_Address: 'CONSTRUCTION, 3551 W 111TH STCHICAGO, IL 60655',
  },
  {
    Service_Type: 'Contractor',
    Id: 62,
    Company_Address: '4415 W HARRISON # 404HILLSIDE, IL 60162',
    Company_Name: 'CONSTRUCTION SAFETY COUNCIL',
  },
  {
    Company_Address: '939 W NORTH AVE STE 750CHICAGO, IL 60642',
    Service_Type: 'Contractor',
    Company_Name: 'BWF CONSTRUCTION',
    Id: 35,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'ARCHER ENGINEERING CO',
    Id: 126,
    Company_Address: '3154-3160 S ARCHER AVECHICAGO, IL 60608-6293',
  },
  {
    Company_Name: 'PATRICK ENGINEERING,INC.& PATRICK DRILLING,INC',
    Company_Address: '1741 MOMENTUM PLACE EFTCHICAGO, IL 60678-2206',
    Service_Type: 'Engineer',
    Id: 192,
  },
  {
    Id: 161,
    Company_Name: 'FLUOR ENGINEERING',
    Company_Address: '200 W MONROE STCHICAGO, IL 60606',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '8745 W HIGGINS RD STE 300, 8745 W HIGGINS RD STE 300CHICAGO, IL 60631',
    Service_Type: 'Engineer',
    Id: 184,
    Company_Name: 'MACTEC ENGINEERING & CONSULTING, INC.',
  },
  {
    Company_Name: 'BECAN CONSTRUCTION CO. OF ILLINOIS., INC',
    Id: 19,
    Service_Type: 'Contractor',
    Company_Address: '4335 S WESTERN AVECHICAGO, IL 60609',
  },
  {
    Company_Address: '8745 W HIGGINS RD STE 300, 8745 W HIGGINS RD STE 300CHICAGO, IL 60631',
    Company_Name: 'MACTEC ENGINEERING & CONSULTING, INC.',
    Service_Type: 'Engineer',
    Id: 184,
  },
  {
    Company_Name: 'GENSLER ARCHITECTURES P C',
    Service_Type: 'Architect',
    Company_Address: '30 W MONROE ST STE 400CHICAGO, IL 60603',
    Id: 108,
  },
  {
    Service_Type: 'Architect',
    Company_Name: '4240 ARCHITECTURE INC',
    Id: 99,
    Company_Address: '247 S STATE ST # 300CHICAGO, IL 60604',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '356 SMOKE TREE BUSINESS PARKNORTH AURORA, IL 60542',
    Id: 180,
    Company_Name: 'KRAGH ENGINEERING INC',
  },
  {
    Service_Type: 'Engineer',
    Id: 137,
    Company_Name: 'CHRISTOPHER B. BURKE ENGINEERING, LIMITED',
    Company_Address: '9575 W HIGGINS RDDES PLAINES, IL 60018',
  },
  {
    Company_Name: 'INFRASTRUCTURE ENGINEERING INC',
    Service_Type: 'Engineer',
    Company_Address: '1 S WACKER DR STE 2650CHICAGO, IL 60606',
    Id: 173,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'SAFETY ENGINEERING ASSOCIATES.',
    Id: 201,
    Company_Address: '2798 S FISH HATCHERY RDMADISON, WI 53711-5398',
  },
  {
    Service_Type: 'Architect',
    Id: 109,
    Company_Address: 'C/OLYMPIC TOWER #200, 300 PEARL STBUFFALO, NY 14202',
    Company_Name: 'INFORMATION ARCHITECTURE GROUP, IN',
  },
  {
    Id: 117,
    Company_Address: '2942 W JARLATH STCHICAGO, IL 60645',
    Company_Name: 'AAA ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Id: 50,
    Company_Address: 'PO BOX 37-9243CHICAGO, IL 60637-9243',
    Company_Name: 'CMA CONSTRUCTION, INC.',
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '579 N FIRST BANK DR STE 220PALATINE, IL 60067',
    Id: 56,
    Company_Name: 'CONSTRUCTION BUSINESS MEDIA LL',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Engineer',
    Id: 221,
    Company_Address: 'COMPANY, INC, 2300 MICHIGAN STHAMMOND, IN 46320',
    Company_Name: 'VIKING ENGINEERING COMPANY, INC',
  },
  {
    Company_Address: '1801 INDUSTRIAL CIRWEST DES MOINES, IA 50265',
    Company_Name: 'BARKER LEMAR ENGINEERING CONSULTANTS',
    Service_Type: 'Engineer',
    Id: 128,
  },
  {
    Service_Type: 'Contractor',
    Id: 10,
    Company_Name: 'AMERICAN ELECTRIC CONSTRUCTION COMPANY LLC',
    Company_Address: '620 PRATT AVE NORTHSCHAUMBURG, IL 60193',
  },
  {
    Company_Address: 'PO BOX 95996CHICAGO, IL 60694',
    Id: 143,
    Service_Type: 'Engineer',
    Company_Name: 'COMPRESSOR ENGINEERING CO',
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'DELTA ENGINEERING GROUP LLC',
    Id: 146,
    Company_Address: '111 W JACKSON BLVD STE 910CHICAGO, IL 60604',
  },
  {
    Service_Type: 'Engineer',
    Id: 118,
    Company_Name: 'ABNA ENGINEERING INC.',
    Company_Address: '10610 S WESTERN AVECHICAGO, IL 60643',
  },
  {
    Company_Address: '2021 MIDWEST RD STE 204HINSDALE, IL 60521',
    Service_Type: 'Engineer',
    Id: 210,
    Company_Name: 'T ENGINEERING SERVICE LIMITED',
  },
  {
    Company_Name: 'XEROX ENGINEERING SYSTEMS',
    Company_Address: '2301 W 22ND ST STE 209OAK BROOK, IL 60523',
    Service_Type: 'Engineer',
    Id: 225,
  },
  {
    Company_Name: 'BMW CONSTRUCTION',
    Company_Address: '1280 GRIFFITH LAKE AVECHESTERTON, IN 46304',
    Id: 31,
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Engineer',
    Id: 151,
    Company_Address: '5901 N CICERO AVE # 404CHICAGO, IL 60646',
    Company_Name: 'EAGLE ENGINEERING, LIMITED',
  },
  {
    Id: 53,
    Service_Type: 'Contractor',
    Company_Name: 'CONSTRUCTION',
    Company_Address: 'SPECIFICATIONS INSTITUTE, 601 MADISON STALEXANDRIA, VA 22314-1791',
  },
  {
    Company_Address: '104 S MICHIGAN AVECHICAGO, IL 60603',
    Service_Type: 'Contractor',
    Company_Name: 'BERGLUND CONSTRUCTION CO',
    Id: 24,
  },
  {
    Company_Address: '921 N LA SALLE DR # 6CHICAGO, IL 60610',
    Id: 197,
    Company_Name: 'RICE HUSTON DESIGN/ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Id: 70,
    Company_Name: 'DUNNET BAY CONSTRUCTION COMPANY',
    Service_Type: 'Contractor',
    Company_Address: '115 N BRANDON DRGLENDALE HEIGHTS, IL 60139',
  },
  {
    Company_Address: '546 W WASHINGTON BLVDCHICAGO, IL 60606',
    Company_Name: 'THATCHER ENGINEERING CORP',
    Id: 214,
    Service_Type: 'Engineer',
  },
  {
    Id: 194,
    Company_Name: 'POLLUTION ENGINEERING',
    Company_Address: 'PO BOX 2144SKOKIE, IL 60076',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '238 S KENILWORTH AVEOAK PARK, IL 60302',
    Id: 215,
    Company_Name: 'THOMAS ENGINEERING GROUP, LLC.',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '2140 W VAN BUREN STCHICAGO, IL 60612',
    Id: 4,
    Company_Name: 'AKMA CONSTRUCTION COMPANY., INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'HENNEMAN ENGINEERING INC',
    Service_Type: 'Engineer',
    Id: 171,
    Company_Address: '1605 S STATE STCHAMPAIGN, IL 61820',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '902 E PLAINFIELDOSWEGO, IL 60543',
    Id: 73,
    Company_Name: 'ED HENRY CONCRETE CONSTRUCTION',
  },
  {
    Company_Name: 'CABO CONSTRUCTION CORP.',
    Id: 37,
    Service_Type: 'Contractor',
    Company_Address: '3155 S SHIELDS AVECHICAGO, IL 60609',
  },
  {
    Id: 85,
    Company_Address: '2630 N MILWAUKEE AVECHICAGO, IL 60647',
    Company_Name: 'FELIX.CARDONA. CONSTRUCTION',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'CONSORTIUM FOR DESIGN & CONSTRUCTION CAREERS',
    Company_Address: '150 S WACKER DR STE 1900CHICAGO, IL 60606',
    Service_Type: 'Contractor',
    Id: 52,
  },
  {
    Id: 169,
    Company_Address: '215 W MAIN ST, STE L-1PLAINFIELD, IL 60601',
    Company_Name: 'HARBOUR ENGINEERING, INC',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '371 S EVERGREENBENSENVILLE, IL 60106',
    Service_Type: 'Contractor',
    Company_Name: 'G&V CONSTRUCTION COMPANY',
    Id: 96,
  },
  {
    Company_Name: 'PAN-OCEANIC ENGINEERING CO INC',
    Company_Address: '6436 W HIGGINS AVENUE EFTCHICAGO, IL 60656',
    Service_Type: 'Engineer',
    Id: 191,
  },
  {
    Company_Address: '6615 N AVONDALE AVE FL 1STCHICAGO, IL 60631',
    Id: 16,
    Company_Name: 'BAYFIELD CONSTRUCTION INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Address: 'Company_Address',
    Company_Name: 'Company_Name',
    Id: 'Id',
    Service_Type: 'Service_Type',
  },
  {
    Company_Name: 'EJM ENGINEERING INC.',
    Company_Address: '411 S WELLS STREET EFTCHICAGO, IL 60607',
    Id: 153,
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'CONSTRUCTION CAREERS COUNCIL',
    Id: 57,
    Service_Type: 'Contractor',
    Company_Address: '5410 S STATE STREET EFTCHICAGO, IL 60609',
  },
  {
    Company_Address: '7000 FRONTAGE RD , IL 60521',
    Id: 7,
    Company_Name: 'ALL CONCRETE CONSTRUCTION INC',
    Service_Type: 'Contractor',
  },
  {
    Id: 86,
    Company_Address: '3611 S NORMAL AVECHICAGO, IL 60609',
    Company_Name: 'FERRO & DIPIAZZA CONSTRUCTION INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'CITY CONSTRUCTION COMPANY INC.',
    Id: 47,
    Company_Address: '4403 W LAWRENCE AVE STE 205  EFTCHICAGO, IL 60630',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'FOUNDATION ENGINEERING, INC.',
    Id: 162,
    Company_Address: '3607 CRESTVIEW DRLAKE ZURICH, IL 60047',
    Service_Type: 'Engineer',
  },
  {
    Id: 182,
    Company_Name: 'LENOCH ENGINEERING, INC',
    Service_Type: 'Engineer',
    Company_Address: '6201 JOLIET RD  1LA GRANGE, IL 60525',
  },
  {
    Id: 152,
    Company_Name: 'EFFECTIVE ENGINEERING INC',
    Service_Type: 'Engineer',
    Company_Address: '2805 W EMPIRE AVEBURBANK, CA 91504',
  },
  {
    Id: 139,
    Service_Type: 'Engineer',
    Company_Name: 'CIVILTECH ENGINEERING INC',
    Company_Address: '450 E DEVON AVE STE 300ITASCA, IL 60143',
  },
  {
    Id: 153,
    Service_Type: 'Engineer',
    Company_Name: 'EJM ENGINEERING INC.',
    Company_Address: '411 S WELLS STREET EFTCHICAGO, IL 60607',
  },
  {
    Company_Name: 'CHARTWELLS.L. ANDREWS CONSTRUCTION',
    Id: 43,
    Company_Address: '3333 W ARTHINGTON ST STE 445CHICAGO, IL 60634',
    Service_Type: 'Contractor',
  },
  {
    Id: 54,
    Company_Name: "CONSTRUCTION & GENRAL LABORS'",
    Company_Address: '1550 S INDIANA AVECHICAGO, IL 60605',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Engineer',
    Id: 137,
    Company_Address: '9575 W HIGGINS RDDES PLAINES, IL 60018',
    Company_Name: 'CHRISTOPHER B. BURKE ENGINEERING, LIMITED',
  },
  {
    Service_Type: 'Engineer',
    Id: 147,
    Company_Name: 'DELTA ENGINEERING, INC.',
    Company_Address: '111 W JACKSON BLVD STE 910, STE 500CHICAGO, IL 60604',
  },
  {
    Service_Type: 'Engineer',
    Id: 212,
    Company_Name: 'TERRA ENGINEERING',
    Company_Address: '225 W OHIO ST FL 4THCHICAGO, IL 60654',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '3893 INDUSTRIAL AVEROLLING MEADOWS, IL 60008',
    Company_Name: 'BERG ENGINEERING & SALES CO.',
    Id: 130,
  },
  {
    Company_Name: 'LENOCH ENGINEERING, INC',
    Id: 182,
    Company_Address: '6201 JOLIET RD  1LA GRANGE, IL 60525',
    Service_Type: 'Engineer',
  },
  {
    Id: 102,
    Company_Address: '4 W BURTON PLCHICAGO, IL 60610',
    Service_Type: 'Architect',
    Company_Name: 'CHICAGO ARCHITECTURE BIENNIAL',
  },
  {
    Company_Name: 'FORSGREN CONSTRUCTION CO.',
    Service_Type: 'Contractor',
    Id: 92,
    Company_Address: '9125 TRIPPOAK LAWN, IL 60453',
  },
  {
    Service_Type: 'Contractor',
    Id: 7,
    Company_Address: '7000 FRONTAGE RD , IL 60521',
    Company_Name: 'ALL CONCRETE CONSTRUCTION INC',
  },
  {
    Company_Name: 'ED HENRY CONCRETE CONSTRUCTION',
    Id: 74,
    Service_Type: 'Contractor',
    Company_Address: '299 OLD HIGGINS RDDES PLAINES, IL 60018',
  },
  {
    Company_Name: 'D & P CONSTRUCTION COMPANY., INC.',
    Service_Type: 'Contractor',
    Company_Address: '8601 W BRYN MAWR AVE # 116CHICAGO, IL 60631',
    Id: 66,
  },
  {
    Company_Name: 'BOLLER CONSTRUCTION COMPANY INC',
    Id: 32,
    Service_Type: 'Contractor',
    Company_Address: '3045 W WASHINGTON STWAUKEGAN, IL 60085',
  },
  {
    Service_Type: 'Engineer',
    Id: 147,
    Company_Name: 'DELTA ENGINEERING, INC.',
    Company_Address: '111 W JACKSON BLVD STE 910, STE 500CHICAGO, IL 60604',
  },
  {
    Company_Address: '104 S MICHIGAN AVECHICAGO, IL 60603',
    Id: 24,
    Service_Type: 'Contractor',
    Company_Name: 'BERGLUND CONSTRUCTION CO',
  },
  {
    Company_Name: 'INTELLIGENT ENGINEERING & DESIGN LLC',
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 337HINCKLEY, IL 60520',
    Id: 174,
  },
  {
    Service_Type: 'Architect',
    Company_Address: '845 W HARRISON STCHICAGO, IL 60607-7024',
    Company_Name: 'UIC-SCHOOL OF ARCHITECTURE',
    Id: 114,
  },
  {
    Id: 9,
    Service_Type: 'Contractor',
    Company_Address: 'CONTROLS, INC., 12225 DISK DRLOCKPORT, IL 60441',
    Company_Name: 'ALTERNATE CONSTRUCTION CONTROLS, INC.',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '1241 SHORELINE DRAURORA, IL 60504',
    Id: 125,
    Company_Name: 'APEX ENGINEERING PRODUCTS CORPORATION',
  },
  {
    Company_Name: 'Company_Name',
    Company_Address: 'Company_Address',
    Id: 'Id',
    Service_Type: 'Service_Type',
  },
  {
    Id: 189,
    Company_Name: 'MILHOUSE ENGINEERING & CONSTRUCTION INC.',
    Service_Type: 'Engineer',
    Company_Address: '60 E VAN BUREN EFTCHICAGO, IL 60605',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'G & V CONSTRUCTION CO INC',
    Company_Address: '371 S EVERGREEN STREET EFTBENSENVILLE, IL 60106',
    Id: 95,
  },
  {
    Company_Address: '939 W NORTH AVE STE 750CHICAGO, IL 60642',
    Company_Name: 'BWF CONSTRUCTION',
    Id: 35,
    Service_Type: 'Contractor',
  },
  {
    Id: 44,
    Service_Type: 'Contractor',
    Company_Address: '1340 W 171ST STHAZEL CREST, IL 60429',
    Company_Name: 'CHICAGO PAVING & CONSTRUCTION',
  },
  {
    Company_Name: 'SCHIRMER ENGINEERING CORP.',
    Id: 204,
    Company_Address: '707 LAKE COOK RDDEERFIELD, IL 60015-4997',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '2072 W PALATINE RDPALATINE, IL 60067',
    Company_Name: 'CONSTRUCTION SAFETY & CHEMICAL SOLUTIONS',
    Service_Type: 'Contractor',
    Id: 61,
  },
  {
    Id: 14,
    Service_Type: 'Contractor',
    Company_Address: '1325 EAST PARK STTAYLORVILLE, IL 62568',
    Company_Name: 'B & R CONSTRUCTION INC',
  },
  {
    Id: 21,
    Company_Address: '3741 S PULASKI RDCHICAGO, IL 60623',
    Company_Name: 'BENCHMARK CONSTRUCTION CO, INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'TIOGA ENGINEERING',
    Company_Address: 'PO BOX 913WELLSBORO, PA 16901',
    Service_Type: 'Engineer',
    Id: 216,
  },
  {
    Company_Address: '1280 GRIFFITH LAKE AVECHESTERTON, IN 46304',
    Id: 31,
    Service_Type: 'Contractor',
    Company_Name: 'BMW CONSTRUCTION',
  },
  {
    Id: 183,
    Service_Type: 'Engineer',
    Company_Name: 'LUEDTKE ENGINEERING CO',
    Company_Address: '10 FOURTH STFRANKFORT, MI 49635',
  },
  {
    Company_Name: 'TEXAS A & M ENGINEERING EXTENSION SERVICE FINANCIAL SERVICES',
    Id: 213,
    Company_Address: 'PO BOX 40006COLLEGE STATION, TX 77842',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '303 W ERIE STCHICAGO, IL 60654',
    Company_Name: 'SAM SCHWARTZ ENGINEERING D. P. C.',
    Service_Type: 'Engineer',
    Id: 202,
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 95996CHICAGO, IL 60694',
    Id: 143,
    Company_Name: 'COMPRESSOR ENGINEERING CO',
  },
  {
    Company_Address: '11789 CONDOR LNHUNTLEY, IL 60142',
    Id: 34,
    Company_Name: 'BURKE CONSTRUCTION CO, INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'HENNEMAN ENGINEERING INC',
    Id: 171,
    Company_Address: '1605 S STATE STCHAMPAIGN, IL 61820',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'CHICAGOLAND CONSTRUCTION, INC.',
    Company_Address: '950 N VILLA AVEVILLA PARK, IL 60181',
    Id: 46,
    Service_Type: 'Contractor',
  },
  {
    Id: 12,
    Service_Type: 'Contractor',
    Company_Name: 'AREATHA CONSTRUCTION CO., INC.',
    Company_Address: '410 E NORTH AVESTREAMWOOD, IL 60107',
  },
  {
    Company_Name: 'E J M ENGINEERING, P.C.',
    Id: 149,
    Company_Address: '411 S WELLS ST STE 800CHICAGO, IL 60607',
    Service_Type: 'Engineer',
  },
  {
    Id: 133,
    Company_Address: '9400 WARD PKWYKANSAS CITY, MO 64114-3319',
    Service_Type: 'Engineer',
    Company_Name: 'BURNS & MCDONNELL ENGINEERING CO. INC.',
  },
  {
    Id: 120,
    Company_Address: 'PO BOX 456PARK RIDGE, IL 60068',
    Company_Name: 'AEROTEC ENGINEERING & CONS INC',
    Service_Type: 'Engineer',
  },
  {
    Id: 190,
    Service_Type: 'Engineer',
    Company_Address: '1950 N WASHINGTON STNAPERVILLE, IL 60566-0353',
    Company_Name: 'PACKER ENGINEERING INC',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '6038 N HARLEM AVECHICAGO, IL 60631',
    Id: 98,
    Company_Name: 'GAVIN CONSTRUCTION COMPANY., INC',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '516 W BRIAR PLCHICAGO, IL 60657',
    Company_Name: 'BRECHEISEN ENGINEERING',
    Id: 132,
  },
  {
    Id: 94,
    Company_Name: 'G & V CONSTRUCTION CO INC',
    Service_Type: 'Contractor',
    Company_Address: '5239 W DIVERSEY AVECHICAGO, IL 60639',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: 'AN L & J TECHNOLOGIES COMPANY, PO BOX 92136CHICAGO, IL 60675-2136',
    Company_Name: 'L & J ENGINEERING',
    Id: 181,
  },
  {
    Company_Address: 'C/O EAST SIDE BANK & TRUST CO, 10635 S EWING AVECHICAGO, IL 60617',
    Service_Type: 'Contractor',
    Id: 79,
    Company_Name: 'ERA CONSTRUCTION & DEVELP LIMITED',
  },
  {
    Id: 44,
    Company_Name: 'CHICAGO PAVING & CONSTRUCTION',
    Company_Address: '1340 W 171ST STHAZEL CREST, IL 60429',
    Service_Type: 'Contractor',
  },
  {
    Company_Address: 'PO BOX 517HIGHTSTOWN, NJ',
    Service_Type: 'Engineer',
    Company_Name: 'ENGINEERING NEWS RECORD',
    Id: 156,
  },
  {
    Company_Name: 'MILHOUSE ENGINEERING & CONSTRUCTION INC.',
    Company_Address: '333 S WABASH AVECHICAGO, IL 60604',
    Service_Type: 'Engineer',
    Id: 188,
  },
  {
    Id: 4,
    Service_Type: 'Contractor',
    Company_Name: 'AKMA CONSTRUCTION COMPANY., INC',
    Company_Address: '2140 W VAN BUREN STCHICAGO, IL 60612',
  },
  {
    Company_Address: '303 W ERIE STCHICAGO, IL 60654',
    Id: 202,
    Company_Name: 'SAM SCHWARTZ ENGINEERING D. P. C.',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'CONSTRUCTION SERVICE ASSOCIATES',
    Company_Address: '166 W WASHINGTON ST # 750CHICAGO, IL 60602',
    Id: 63,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: 'WINTHROP ROAD ROUTE 145CHESTER, CT',
    Service_Type: 'Engineer',
    Company_Name: 'WHELEN ENGINEERING COMPANY',
    Id: 224,
  },
  {
    Id: 175,
    Company_Name: 'INTERNATIONAL ENGINEERING CONSULTANTS, INC.',
    Company_Address: 'CONSULTANTS, INC., 188 W RANDOLPH ST STE 1826CHICAGO, IL 60601',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'BOWEN ENGINEERING CORP',
    Id: 131,
    Service_Type: 'Engineer',
    Company_Address: 'PO BOX 40729INDIANAPOLIS, IN 46240',
  },
  {
    Company_Name: 'GENSLER ARCHITECTURES P C',
    Id: 108,
    Company_Address: '30 W MONROE ST STE 400CHICAGO, IL 60603',
    Service_Type: 'Architect',
  },
  {
    Id: 73,
    Service_Type: 'Contractor',
    Company_Name: 'ED HENRY CONCRETE CONSTRUCTION',
    Company_Address: '902 E PLAINFIELDOSWEGO, IL 60543',
  },
  {
    Company_Name: 'ERA CONSTRUCTION & DEVELP LIMITED',
    Service_Type: 'Contractor',
    Company_Address: 'C/O EAST SIDE BANK & TRUST CO, 10635 S EWING AVECHICAGO, IL 60617',
    Id: 79,
  },
  {
    Company_Name: 'ESD CONSTRUCTION INC.',
    Company_Address: '175 W JACKSON BLVD # 1400CHICAGO, IL 60604',
    Id: 80,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: 'PO BOX 1275WOODLAND HILLS, CA 91365',
    Service_Type: 'Engineer',
    Company_Name: 'RONAN ENGINEERING COMPANY',
    Id: 198,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'MIDWEST ENGINEERING SERVICE, INC',
    Id: 187,
    Company_Address: '1507 E SUNSET DRIVE-STE  125WAUKESHA, WI 53189-8213',
  },
  {
    Company_Name: 'FARR ASSOCIATES, ARCHITECTURE & URBAN DESIGN, INC',
    Service_Type: 'Architect',
    Id: 106,
    Company_Address: '& URBAN DESIGN, 53 W JACKSON BLVD STE 650CHICAGO, IL 60604',
  },
  {
    Id: 197,
    Company_Name: 'RICE HUSTON DESIGN/ENGINEERING',
    Service_Type: 'Engineer',
    Company_Address: '921 N LA SALLE DR # 6CHICAGO, IL 60610',
  },
  {
    Company_Name: 'MILHOUSE ENGINEERING & CONSTRUCTION INC.',
    Id: 188,
    Service_Type: 'Engineer',
    Company_Address: '333 S WABASH AVECHICAGO, IL 60604',
  },
  {
    Company_Address: 'PO BOX 801123KANSAS CITY, MO 64180-0123',
    Service_Type: 'Contractor',
    Company_Name: 'BLACK & VEATCH CONSTRUCTION CO',
    Id: 28,
  },
  {
    Company_Address: '2737 W TOUHY AVECHICAGO, IL 60602',
    Service_Type: 'Contractor',
    Company_Name: 'CHARLES CARPETS & CONSTRUCTIONS',
    Id: 42,
  },
  {
    Company_Address: '410 E NORTH AVESTREAMWOOD, IL 60107',
    Company_Name: 'AREATHA CONSTRUCTION CO., INC.',
    Id: 12,
    Service_Type: 'Contractor',
  },
  {
    Company_Address: '371 S EVERGREENBENSENVILLE, IL 60106',
    Id: 96,
    Company_Name: 'G&V CONSTRUCTION COMPANY',
    Service_Type: 'Contractor',
  },
  {
    Id: 20,
    Service_Type: 'Contractor',
    Company_Address: 'PO BOX 277  EFTTINLEY PARK, IL 60477',
    Company_Name: 'BECHSTEIN CONSTRUCTION CORP',
  },
  {
    Company_Address: '700 N SACRAMENTO BOULEVARD EFTCHICAGO, IL 60612',
    Company_Name: 'PIONEER ENGINEERING & ENVIRONMENTAL SERVICES, LLC',
    Service_Type: 'Engineer',
    Id: 193,
  },
  {
    Id: 99,
    Service_Type: 'Architect',
    Company_Address: '247 S STATE ST # 300CHICAGO, IL 60604',
    Company_Name: '4240 ARCHITECTURE INC',
  },
  {
    Company_Address: '5824 W 83RD STBURBANK, IL 60459',
    Company_Name: 'C3 CONSTRUCTION SERVICES INC',
    Service_Type: 'Contractor',
    Id: 36,
  },
  {
    Id: 33,
    Company_Name: 'BROADWAY CONSTRUCTION, INC',
    Service_Type: 'Contractor',
    Company_Address: '6577 N AVONDALE AVECHICAGO, IL 60631',
  },
  {
    Service_Type: 'Engineer',
    Id: 172,
    Company_Address: '120 WALL ST FL 17THNEW YORK, NY 10005-4001',
    Company_Name: 'ILLUMINATING ENGINEERING SOC.',
  },
  {
    Company_Name: "FLYNN'S CORNERSTONE CONSTRUCTION COMPANY",
    Service_Type: 'Contractor',
    Company_Address: 'CONSTRUCTION COMPANY, 4545 S WESTERN BLVD # 2-BCHICAGO, IL 60609',
    Id: 91,
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'CMA CONSTRUCTION, INC.',
    Id: 50,
    Company_Address: 'PO BOX 37-9243CHICAGO, IL 60637-9243',
  },
  {
    Id: 133,
    Company_Address: '9400 WARD PKWYKANSAS CITY, MO 64114-3319',
    Company_Name: 'BURNS & MCDONNELL ENGINEERING CO. INC.',
    Service_Type: 'Engineer',
  },
  {
    Company_Address: '356 SMOKE TREE BUSINESS PARKNORTH AURORA, IL 60542',
    Company_Name: 'KRAGH ENGINEERING INC',
    Service_Type: 'Engineer',
    Id: 180,
  },
  {
    Company_Address: 'PO BOX 2144SKOKIE, IL 60076',
    Company_Name: 'POLLUTION ENGINEERING',
    Id: 194,
    Service_Type: 'Engineer',
  },
  {
    Id: 28,
    Company_Name: 'BLACK & VEATCH CONSTRUCTION CO',
    Company_Address: 'PO BOX 801123KANSAS CITY, MO 64180-0123',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'ESD CONSTRUCTION INC.',
    Company_Address: '175 W JACKSON BLVD # 1400CHICAGO, IL 60604',
    Service_Type: 'Contractor',
    Id: 80,
  },
  {
    Company_Address: '10 S LA SALLE ST STE 300CHICAGO, IL 60603',
    Id: 49,
    Company_Name: 'CLUNE CONSTRUCTION COMPANY',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '420 N MAIN STMONTGOMERY, IL 60538',
    Company_Name: 'ENGINEERING ANSWERS INC',
    Id: 155,
  },
  {
    Company_Address: '11789 CONDOR LNHUNTLEY, IL 60142',
    Id: 34,
    Company_Name: 'BURKE CONSTRUCTION CO, INC',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'H D R ENGINEERING, INC.',
    Service_Type: 'Engineer',
    Company_Address: '8550 W BRYN MAWR AVECHICAGO, IL 60631',
    Id: 168,
  },
  {
    Id: 72,
    Company_Name: 'E.B.T CONSTRUCTION INC.',
    Company_Address: '517 W 97TH STCHICAGO, IL 60628-1115',
    Service_Type: 'Contractor',
  },
  {
    Id: 123,
    Service_Type: 'Engineer',
    Company_Name: 'AMERICAN COUNCIL OF ENGINEERING COMPANIES',
    Company_Address: '1015 15TH ST NWWASHINGTON, DC 20005',
  },
  {
    Id: 5,
    Company_Address: '21 W 180 HILL AVEGLEN ELLYN, IL 60137',
    Company_Name: 'ALBERT WENDT CONSTRUCTION CO',
    Service_Type: 'Contractor',
  },
  {
    Company_Name: 'REGINALD B. WILSON ARCHITECTURE',
    Company_Address: '601 E 32ND ST # 1203CHICAGO, IL 60616',
    Service_Type: 'Architect',
    Id: 113,
  },
  {
    Company_Address: '450 E DEVON AVE STE 300ITASCA, IL 60143',
    Id: 139,
    Company_Name: 'CIVILTECH ENGINEERING INC',
    Service_Type: 'Engineer',
  },
  {
    Id: 205,
    Company_Name: 'SCI ENGINEERING INC',
    Company_Address: '650 PIERCE BLVDO FALLON, IL 62269',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '145 TOWER DRBURR RIDGE, IL 60527',
    Company_Name: 'ALL-BRY CONSTRUCTION COMPANY',
    Id: 8,
  },
  {
    Company_Name: 'BAYWOOD CONSTRUCTION CO',
    Id: 17,
    Service_Type: 'Contractor',
    Company_Address: '6215 N FOREST GLEN AVECHICAGO, IL 60646',
  },
  {
    Id: 207,
    Company_Address: '19 S BOTHWELL STPALATINE, IL 60067-5010',
    Company_Name: 'SETON ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Service_Type: 'Engineer',
    Id: 186,
    Company_Name: 'MC CARTHY RADIO ENGINEERING',
    Company_Address: 'PO BOX 445MOUNT PROSPECT, IL 60056-0045',
  },
  {
    Id: 190,
    Company_Name: 'PACKER ENGINEERING INC',
    Service_Type: 'Engineer',
    Company_Address: '1950 N WASHINGTON STNAPERVILLE, IL 60566-0353',
  },
  {
    Service_Type: 'Contractor',
    Id: 43,
    Company_Name: 'CHARTWELLS.L. ANDREWS CONSTRUCTION',
    Company_Address: '3333 W ARTHINGTON ST STE 445CHICAGO, IL 60634',
  },
  {
    Id: 59,
    Service_Type: 'Contractor',
    Company_Name: 'CONSTRUCTION DATA SERVICES',
    Company_Address: '400 OSER AVEHAUPPAUGE, NY 11788',
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'PATRICK ENGINEERING,INC.& PATRICK DRILLING,INC',
    Id: 192,
    Company_Address: '1741 MOMENTUM PLACE EFTCHICAGO, IL 60678-2206',
  },
  {
    Company_Address: '6038 N HARLEM AVECHICAGO, IL 60631',
    Service_Type: 'Contractor',
    Id: 98,
    Company_Name: 'GAVIN CONSTRUCTION COMPANY., INC',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: '30 OSER AVE STE 500HAUPPAUGE, NY 11788',
    Id: 40,
    Company_Name: 'CBE CONSTRUCTION BOOK EXPRESS',
  },
  {
    Id: 186,
    Company_Address: 'PO BOX 445MOUNT PROSPECT, IL 60056-0045',
    Company_Name: 'MC CARTHY RADIO ENGINEERING',
    Service_Type: 'Engineer',
  },
  {
    Company_Name: 'PAMELA SELF LANDSCAPE ARCHITECTURE LIMITED',
    Company_Address: 'ONE ANNE COURTHAWTHORN WOODS, IL 60047',
    Service_Type: 'Architect',
    Id: 112,
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'CONSTRUCTION MANAGEMENT ASSOC.',
    Id: 60,
    Company_Address: 'AMERICA-D/B/A-CMAA, 7926 JONES BRAND DR # 800MCLEAN, VA 22102',
  },
  {
    Company_Address: '8550 W BRYN MAWR AVECHICAGO, IL 60631',
    Id: 168,
    Service_Type: 'Engineer',
    Company_Name: 'H D R ENGINEERING, INC.',
  },
  {
    Company_Address: '111 E WACKER DR STE 1321CHICAGO, IL 60601',
    Service_Type: 'Architect',
    Id: 103,
    Company_Name: 'CHICAGO ARCHITECTURE FOUNDATION',
  },
  {
    Company_Name: 'ED HENRY CONCRETE CONSTRUCTION',
    Company_Address: '299 OLD HIGGINS RDDES PLAINES, IL 60018',
    Id: 74,
    Service_Type: 'Contractor',
  },
  {
    Id: 159,
    Service_Type: 'Engineer',
    Company_Name: 'EXPLICO ENGINEERING',
    Company_Address: '40028 GRAND RIVER AVE  STE300NOVI, MI 48375',
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'FERRO CONSTRUCTION COMPANY.INC',
    Company_Address: '12100 S MARSHFIELD AVE, # 6CALUMET PARK, IL 60632',
    Id: 87,
  },
  {
    Service_Type: 'Engineer',
    Company_Name: 'ABNA ENGINEERING INC.',
    Id: 118,
    Company_Address: '10610 S WESTERN AVECHICAGO, IL 60643',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '30 E ADAMS ST STE 1100CHICAGO, IL 60603',
    Id: 211,
    Company_Name: 'TECHKNOW ENGINEERING, LLC',
  },
  {
    Company_Address: '6702 FOREST VIEW LANENILES, IL 60714',
    Service_Type: 'Engineer',
    Company_Name: 'J & S TOOL & ENGINEERING CO INC',
    Id: 176,
  },
  {
    Id: 92,
    Company_Name: 'FORSGREN CONSTRUCTION CO.',
    Service_Type: 'Contractor',
    Company_Address: '9125 TRIPPOAK LAWN, IL 60453',
  },
  {
    Company_Name: 'BENCHMARK CONSTRUCTION CO. INC',
    Id: 22,
    Service_Type: 'Contractor',
    Company_Address: '3349 S KEDZIE AVENUE EFTCHICAGO, IL 60623',
  },
  {
    Id: 3,
    Company_Name: 'AKMA CONSTRUCTION CO, INC.',
    Company_Address: 'PO BOX 12328CHICAGO, IL 60612',
    Service_Type: 'Contractor',
  },
  {
    Id: 105,
    Company_Name: 'DLK ARCHITECTURE, INC.',
    Company_Address: 'B/A DLK CIVIC DESIGN, RIVER PLACE 329 WEST 18TH STREETCHICAGO, IL 60616',
    Service_Type: 'Architect',
  },
  {
    Service_Type: 'Engineer',
    Company_Address: '5901 N CICERO AVE # 404CHICAGO, IL 60646',
    Id: 151,
    Company_Name: 'EAGLE ENGINEERING, LIMITED',
  },
  {
    Id: 172,
    Service_Type: 'Engineer',
    Company_Address: '120 WALL ST FL 17THNEW YORK, NY 10005-4001',
    Company_Name: 'ILLUMINATING ENGINEERING SOC.',
  },
  {
    Company_Name: 'FRIEDLER CONSTRUCTION CO',
    Service_Type: 'Contractor',
    Company_Address: '1001 N MILWAUKEE AVECHICAGO, IL 60642',
    Id: 93,
  },
  {
    Company_Name: 'CONSTRUCTION SAFETY COUNCIL',
    Company_Address: '4415 W HARRISON # 404HILLSIDE, IL 60162',
    Service_Type: 'Contractor',
    Id: 62,
  },
  {
    Service_Type: 'Contractor',
    Company_Name: 'FIRST RANK CONSTRUCTION, INC.',
    Company_Address: '1114 E 119TH STGLENWOOD, IL 60425',
    Id: 88,
  },
  {
    Company_Address: '1200 W CERMAK RDCHICAGO, IL 60608',
    Service_Type: 'Contractor',
    Company_Name: 'FASTENAL IND & CONSTRUCTION',
    Id: 84,
  },
  {
    Id: 130,
    Company_Name: 'BERG ENGINEERING & SALES CO.',
    Service_Type: 'Engineer',
    Company_Address: '3893 INDUSTRIAL AVEROLLING MEADOWS, IL 60008',
  },
  {
    Service_Type: 'Architect',
    Company_Name: 'CHICAGO ARCHITECTURE BIENNIAL',
    Id: 102,
    Company_Address: '4 W BURTON PLCHICAGO, IL 60610',
  },
  {
    Id: 66,
    Service_Type: 'Contractor',
    Company_Address: '8601 W BRYN MAWR AVE # 116CHICAGO, IL 60631',
    Company_Name: 'D & P CONSTRUCTION COMPANY., INC.',
  },
  {
    Id: 42,
    Company_Address: '2737 W TOUHY AVECHICAGO, IL 60602',
    Company_Name: 'CHARLES CARPETS & CONSTRUCTIONS',
    Service_Type: 'Contractor',
  },
  {
    Service_Type: 'Contractor',
    Company_Address: 'PO BOX 66694CHICAGO, IL 60666-0694',
    Company_Name: 'ACE CONSTRUCTION SERVICES',
    Id: 2,
  },
  {
    Company_Address: '626 GROVE STEVANSTON, IL 60201',
    Service_Type: 'Architect',
    Id: 111,
    Company_Name: 'NATHAN KIPNIS ARCHITECTURE,INC',
  },
];
